import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../../shared";
import { DataService_PBISAuto } from "../shared/data.service";

@Component({
	selector: "caass-auto-point-table",
	templateUrl: "./auto-point-table.component.html",
	styleUrls: ["./auto-point-table.component.css"],
})
export class AutoPointTableComponent implements OnInit {
	constructor(private userService: UserService, private PBISAutoService: DataService_PBISAuto, private dialogService: DialogService) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.loadPointsAutomatedItem();
	}

	ngOnChanges() {
		this.loadPointsAutomatedItem();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	@Input() School: any;
	@Output() SelectedChanged: EventEmitter<any> = new EventEmitter();

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedPointsAutomatedItem: any;
	lstPointsAutomatedItem: any = [];

	//Filter lists
	lstPointsAutomatedItemTypeDesc: any = [];
	lstPointsItemDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "PointsAutomatedItemTypeDesc", header: "Trigger" },
		{ field: "PointsItemDesc", header: "Point" },
		{ field: "PointsItemValue", header: "Point Value" },
		{ field: "SchoolCount", header: "School Count" },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadPointsAutomatedItem() {
		if (this.School == undefined || this.School.SchoolID == undefined) {
			return;
		}

		this.loading = true;

		var result = this.PBISAutoService.AutoPointInfoSelectList(this.School.SchoolID);
		result.subscribe(
			(response) => {
				this.lstPointsAutomatedItem = response;

				for (var z = 0; z < this.lstPointsAutomatedItem.length; z++) {
					var next = this.lstPointsAutomatedItem[z];

					next.SchoolCount = next.lstSchools.length;
				}

				//Load Data Filter Lists
				this.lstPointsAutomatedItemTypeDesc = Array.from(
					new Set(this.lstPointsAutomatedItem.map((item: any) => item.PointsAutomatedItemTypeDesc))
				).sort();
				this.lstPointsItemDesc = Array.from(new Set(this.lstPointsAutomatedItem.map((item: any) => item.PointsItemDesc))).sort();

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadPointsAutomatedItem();
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedPointsAutomatedItem = val.data;

		this.SelectedChanged.emit(this.SelectedPointsAutomatedItem);
	}
	onRowUnselect(val) {
		this.SelectedPointsAutomatedItem = null;

		this.SelectedChanged.emit(this.SelectedPointsAutomatedItem);
	}
	onRowDblClick(PointsAutomatedItem) {
		this.SelectedPointsAutomatedItem = PointsAutomatedItem;

		this.SelectedChanged.emit(this.SelectedPointsAutomatedItem);
	}
	////////////////////////////////////////////
}
